import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { FetchQueryOptions, QueryClient } from '@tanstack/react-query';
import { PersistQueryClientOptions } from '@tanstack/react-query-persist-client';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 1000 * 60 * 10, // 10 minutes
      staleTime: 1000 * 60 * 10,
      retry: 1,
    },
  },
});

export const persistOptions = {
  persister: createSyncStoragePersister({
    storage: window.sessionStorage,
  }),
} as PersistQueryClientOptions;

export const prefetchLoader = (query: FetchQueryOptions) => () => {
  queryClient.prefetchQuery(query);
  return null;
};
